export default [
    {
        key: 'product.name',
        label: 'Name',
    },
    {
        key: 'product.images',
        label: 'Images',
        variant: 'column-img'
    },
    // TODO: Temporarily hidden
    // {
    //    key: 'product.price',
    //    label: 'Price',
    //    variant: 'column-md'
    // },
    {
        key: 'product.value',
        label: 'Value',
        variant: 'column-md'
    },
    {
        key: 'product.currencyCode',
        label: 'Currency',
        variant: 'column-md'
    },
    {
        key: 'product.sku',
        label: 'SKU',
    },
    {
        key: 'product.fnsku',
        label: 'FNSKU',
    },
    {
        key: 'orderedQuantity',
        label: 'Number of Units',
        variant: 'column-md'
    },
    {
        key: 'action',
        label: '',
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/orderProducts.js